export default "__VITE_ASSET__CR$4TAep__"